import React from "react";
import { Redirect } from "react-router-dom";

import { landingRoute } from "~/common/landing-route";
import { useOptionalUser } from "~/common/user";
import { Loader } from "~/components/ui/loader";
import { selectUser, selectUserIsLoading } from "~/slices/user";
import { useAppSelector } from "~/store";

export function PublicOnly({ children }: { children: React.ReactElement }) {
  const user = useAppSelector(selectUser);
  const userIsLoading = useAppSelector(selectUserIsLoading);

  if (userIsLoading) {
    return <Loader />;
  }

  if (Object.keys(user).length > 0) {
    return <Redirect to={landingRoute()} />;
  }

  return children;
}

export function AuthOnly({ children }: { children: React.ReactNode }) {
  return useOptionalUser() ? <>{children}</> : null;
}

export function SignedOfferOnly({ children }: { children: React.ReactNode }) {
  const maybeUser = useOptionalUser();

  if (!maybeUser || !maybeUser.has_signed_offer) {
    return null;
  }

  return <>{children}</>;
}
